import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ResidentGate } from "@/components/app/portal/pages/resident-gate";

export const Route = createFileRoute("/family-portal/$residentId")({
  component: FamilyResident,
});

/** Every page for one resident, behind one check that the person follows them. */
function FamilyResident() {
  const { residentId } = Route.useParams();
  return (
    <ResidentGate residentId={residentId}>
      <Outlet />
    </ResidentGate>
  );
}
